import * as React from "react";
import { Table, Switch, Row, Popover, Col } from "antd";
import { Tooltip } from "@lunchboxinc/utensils";
import { Titles, ConditionalWrapper, Button } from "components/elements";
import { permissions } from "common/constants";

import {
  Tables,
  AvailabilityStatus,
  Drawers,
  Permissions,
} from "components/fragments";
import { CreateItem } from "components/templates";
import { useUserContext } from "components/providers/User";
import styles from "./options.module.css";

const { CardTitle } = Titles;
const { PersistentTable } = Tables;
const { ResDrawer } = Drawers;
const { Permission } = Permissions;

const {
  methods: { POST },
  routes: { MENU_ITEMS_LIST },
} = permissions;

const popoverContent =
  "The number of selected default modifiers cannot exceed the max modifiers set for the option group.";

const OptionsGroupTable = ({
  locationPathname,
  items,
  history,
  initialDefaultModifiers,
  save,
  saving,
  max,
  optionId,
  fetching,
  createItemFetch,
}) => {
  const user = useUserContext();
  const isMaxModifiers = max ? initialDefaultModifiers.length >= max : false;
  let defaultModifiers = initialDefaultModifiers;

  // Stopping event propagation to stop click from triggering onRow
  const onToggleWrapperClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const isChecked = (id) => defaultModifiers.includes(id);
  const onClick = (id) => (checked) => {
    defaultModifiers = checked
      ? [...defaultModifiers, id]
      : defaultModifiers.filter((prevId) => prevId !== id);

    save({ defaultModifiers }, { saveOptionGroup: true });
  };

  return (
    <>
      <Row>
        <Col span={12}>
          <CardTitle>Options</CardTitle>
        </Col>
        {user.rgConfiguration?.menuEntityCreate && (
          <Permission
            requiredPermissions={[{ method: POST, url: MENU_ITEMS_LIST }]}
            yes={() => (
              <Col span={12}>
                <ResDrawer
                  title="Create Item"
                  placement="right"
                  width="50vw"
                  button={
                    <Button color="blue" size="medium" float="right">
                      Create Item
                    </Button>
                  }
                >
                  {(drawerProps) => (
                    <CreateItem
                      loading={fetching}
                      drawerProps={drawerProps}
                      optionId={optionId}
                      fetchResults={createItemFetch}
                    />
                  )}
                </ResDrawer>
              </Col>
            )}
          />
        )}
      </Row>
      <PersistentTable
        horizontalScrollSize="large"
        persistKey={locationPathname}
        dataSource={items}
        history={history}
        path="/item/"
        loading={fetching}
      >
        <Table.Column title="Name" dataIndex="name" />
        <Table.Column title="GUID" dataIndex="externalId" />
        <Table.Column
          title="Availability"
          width={150}
          dataIndex="isActive"
          render={(text, i) => <AvailabilityStatus available={i.isActive} />}
        />
        <Table.Column
          title="Enabled By Default"
          render={(text, { id }, index) => (
            <button
              className={styles.eventWrapperButton}
              type="button"
              onClick={onToggleWrapperClick}
            >
              <ConditionalWrapper
                condition={isMaxModifiers}
                wrapper={(children) => (
                  <Popover
                    overlayStyle={{ width: 150 }}
                    trigger="hover"
                    placement="top"
                    content={popoverContent}
                  >
                    {children}
                  </Popover>
                )}
              >
                <Switch
                  disabled={saving || (!isChecked(id) && isMaxModifiers)}
                  onClick={onClick(id)}
                  checked={isChecked(id)}
                />
              </ConditionalWrapper>
            </button>
          )}
        />
      </PersistentTable>
    </>
  );
};

export default OptionsGroupTable;
